(() => {
  'use strict';
  const openPanels = () => [...document.querySelectorAll('.bp-delivery-info[open]')];
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    openPanels().forEach(details => {
      const restoreFocus = details.contains(document.activeElement);
      details.open = false;
      if (restoreFocus) {
        event.preventDefault();
        details.querySelector('summary').focus();
      }
    });
  });
  const dismissOutside = event => {
    openPanels().forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  };
  document.addEventListener('pointerdown', dismissOutside);
  document.addEventListener('focusin', dismissOutside);
})();
